shadow$provide[405] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `vec4 mapUVWO(vec4 uvwo, vec4 stpq) {
  return uvwo;
}
`;

};